import { formatDate, formatEndDate } from "presentation/utils/formatEndDate";
import { IEmployeeRepository } from "../../domain/contracts/employee.contract";
import { Employee } from "../../domain/entities/employee";
import { Message } from "../../domain/entities/message";
import { EmployeeInputFilter } from "../../domain/models/employee-input-filter";
import { httpClient } from "../axios/axios-api";
import { ISalaryRepository } from "domain/contracts/salary.contracts";
import { Salary } from "domain/entities/salary";
import { SalaryInputFilter } from "domain/models/salary-input-filter";

class SalaryRepository implements ISalaryRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/salary/${id}`);
    return response.data;
  }

  async create(input: Salary): Promise<Message<Salary>> {
    const response = await httpClient.post(`/salary`, { data: input });
    return response.data;
  }

  async update(input: Salary): Promise<Message<boolean>> {
    const response = await httpClient.put(`/salary/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: SalaryInputFilter): Promise<Message<Salary[]>> {
    const response = await httpClient.get(`/salary`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Salary>> {
    const response = await httpClient.get(`/salary/${id}`);
    return response.data;
  }
}

export default new SalaryRepository();
